<div class="modal-header">
    <h5 class="modal-title tituloPage">Ingresar numero de documento</h5>
</div>

<div class="modal-body">
    <form [formGroup]="formCheckExceptionalBeneficiary" class="content-form" > 
        <div class="row">
            <div class="col-md-6 col-12 mb-3">
                <div class="form-group">
                    <label for="documentType" class="form-label fuenteGeneral">Tipo de Documento</label>
                    <select formControlName="documentType" class="form-select"
                    [ngClass]="{'is-invalid': formCheckExceptionalBeneficiary.get('documentType').invalid && formCheckExceptionalBeneficiary.get('documentType').touched}">
                    <option [ngValue]="null">-- SELECCIONE --</option>
                    <option *ngFor="let documentType of documentTypes" [ngValue]="documentType">
                        {{ documentType.type }}
                    </option>
                    </select>
                    <div *ngIf="formCheckExceptionalBeneficiary.get('documentType').invalid && formCheckExceptionalBeneficiary.get('documentType').touched" class="invalid-feedback">
                    <small>Este campo es obligatorio.</small>
                    </div>
                </div>
            </div>

            <div class="col-md-6 col-12 mb-3">
              <div class="form-group">
                <label for="documentNumber" class="form-label fuenteGeneral">Número de Documento</label>
                
                <input 
                  matInput 
                  maxlength="20" 
                  formControlName="documentNumber" 
                  class="form-control"
                  placeholder="Ingrese su número de documento"
                  (keypress)="validateDocNumberInput($event)"
                  [ngClass]="{
                    'is-invalid': formCheckExceptionalBeneficiary.get('documentNumber')?.invalid && formCheckExceptionalBeneficiary.get('documentNumber')?.touched
                  }">
                <div *ngIf="formCheckExceptionalBeneficiary.get('documentNumber').invalid && formCheckExceptionalBeneficiary.get('documentNumber').touched" class="invalid-feedback">
                  <!--<small>Este campo es obligatorio y debe ser válido.</small>-->
                  <small *ngIf="formCheckExceptionalBeneficiary.get('documentNumber')?.errors?.['required']">
                    Este campo es obligatorio.
                  </small>
                  <small *ngIf="formCheckExceptionalBeneficiary.get('documentNumber')?.errors?.['pattern']">
                    El formato del número de documento es inválido.
                  </small>
                </div>
              </div>
            </div>
        </div>
    </form>
</div>

<div class="modal-footer">
  <div role="group" aria-label="Botones de mantenimiento">
    <button mat-raised-button color="primary" type="button" (click)="checkExceptionalBeneficiary()" name="btnOp2" id="btnOp2"
    [disabled]="formCheckExceptionalBeneficiary.invalid">
      Validar
    </button>
  </div>
</div>